import React from 'react'

class Option extends React.Component {
  render() {
    const { label } = this.props

    return (
      <div className='mt-1'>
        <span className='grey'>{this.props.label}</span>
        {this.props.children}
      </div>
    )
  }
}

export default Option
